import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupText,
} from "reactstrap";

class AddUserEmergencyContactModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.initialState;
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  initialState = {
    userId: this.props.userId,
    fullName: "",
    email: "",
    phoneName: "",
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  }

  addUserBankAccount(e) {
    e.preventDefault();
    this.props.handleSubmit(this.state);
    this.setState(this.initialState);
  }

  render() {
    let { open, toggle } = this.props;
    let { fullName, email, phoneNumber } = this.state;
    return (
      <>
        <Modal isOpen={open} fade={false} toggle={toggle}>
          <ModalHeader toggle={toggle}>Thêm tài khoản ngân hàng</ModalHeader>
          <ModalBody>
            <div class="row">
              <div class="col-md-12">
                <Form onSubmit={(e) => this.addUserBankAccount(e)}>
                  <FormGroup>
                    <Label>Họ và tên</Label>
                    <Input
                      onChange={this.handleInputChange}
                      type="text"
                      required
                      value={fullName}
                      name="fullName"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>Email</Label>
                    <Input
                      onChange={this.handleInputChange}
                      type="text"
                      required
                      value={email}
                      name="email"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>Số điện thoại</Label>
                    <Input
                      onChange={this.handleInputChange}
                      type="text"
                      required
                      value={phoneNumber}
                      name="phoneNumber"
                    />
                  </FormGroup>
                  <Button className="mb-2 me-2" type="submit">
                    Thêm
                  </Button>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default AddUserEmergencyContactModal;
